/** <accordion-component>: one collapsible panel (stack several for a group), avoiding <details>/<summary> which cannot animate — the CSS animates the height with the grid-template-rows 0fr -> 1fr trick; optional data-open, data-disable-above and data-accordion-group. */
(function () {
  if (customElements.get("accordion-component")) return;

  class AccordionComponent extends HTMLElement {
    // Bound once per instance: a portaled drawer moves its subtree to <body>, so connectedCallback runs a second time and an inline arrow would stack a second listener — two toggles per click, i.e. a dead accordion.
    #onClick = (event) => this.#handleClick(event);

    connectedCallback() {
      this.trigger = this.querySelector(":scope > .accordion__trigger");
      this.panel = this.querySelector(":scope > .accordion__panel");
      if (!this.trigger || !this.panel) return;

      // Lie trigger ↔ panel pour les lecteurs d'écran.
      if (!this.panel.id) {
        this.panel.id = `accordion-panel-${Math.random().toString(36).slice(2, 9)}`;
      }
      this.trigger.setAttribute("aria-controls", this.panel.id);
      this.panel.setAttribute("role", "region");
      this.panel.setAttribute("aria-labelledby", this.trigger.id || this.#ensureId(this.trigger));

      this.trigger.addEventListener("click", this.#onClick);

      this.disableAbove =
        this.dataset.disableAbove != null ? parseInt(this.dataset.disableAbove, 10) : null;
      if (this.disableAbove != null) {
        this.mq = window.matchMedia(`(max-width: ${this.disableAbove}px)`);
        this.mqListener = () => this.#applyState();
        if (this.mq.addEventListener) this.mq.addEventListener("change", this.mqListener);
        else this.mq.addListener(this.mqListener);
      }

      // État initial : data-open inline, sinon data-default-open, sinon fermé.
      if (!this.dataset.open) {
        this.dataset.open = this.dataset.defaultOpen === "true" ? "true" : "false";
      }
      this.#applyState();
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener("click", this.#onClick);
      if (!this.mq) return;
      if (this.mq.removeEventListener) this.mq.removeEventListener("change", this.mqListener);
      else this.mq.removeListener(this.mqListener);
    }

    #ensureId(el) {
      if (!el.id) el.id = `accordion-trigger-${Math.random().toString(36).slice(2, 9)}`;
      return el.id;
    }

    /** Vrai si au-dessus du breakpoint (toggle bloqué, forcé ouvert). */
    #isDisabled() {
      if (this.disableAbove == null) return false;
      return !this.mq.matches;
    }

    #setOpen(open) {
      this.dataset.open = open ? "true" : "false";
      this.trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }

    #applyState() {
      if (this.#isDisabled()) {
        this.#setOpen(true);
      } else {
        this.#setOpen(this.dataset.open === "true");
      }
    }

    /** Ferme l'accordéon (API publique, utilisée par le mode groupe). */
    close() {
      if (this.#isDisabled()) return;
      this.#setOpen(false);
    }

    #handleClick(event) {
      if (this.#isDisabled()) {
        event.preventDefault();
        return;
      }
      const willOpen = this.dataset.open !== "true";
      this.#setOpen(willOpen);
      // Mode exclusif : à l'ouverture, referme les autres du même groupe.
      if (willOpen) this.#closeGroupSiblings();
    }

    /** data-accordion-group : referme les autres accordéons du même groupe. */
    #closeGroupSiblings() {
      const group = this.dataset.accordionGroup;
      if (!group) return;
      const members = document.querySelectorAll(
        `accordion-component[data-accordion-group="${CSS.escape(group)}"]`,
      );
      members.forEach((el) => {
        if (el !== this && typeof el.close === "function") el.close();
      });
    }
  }

  customElements.define("accordion-component", AccordionComponent);
})();
